// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2gCz9","topBottomGutter":"Layout_topBottomGutter__2VqTB"};